import React, { useEffect, useState } from "react";

const UserCertificatePage = () => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_LMS_APP_BASE_URL;

  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${baseUrl}/certificate/my-certificates`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        });

        if (!res.ok) throw new Error("Failed to fetch certificates");
        const data = await res.json();
        setCertificates(data.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificates();
  }, [baseUrl]);

  if (loading) return <div className="p-6 text-center">Loading certificates...</div>;
  if (error) return <div className="p-6 text-center text-red-600">Error: {error}</div>;
  if (certificates.length === 0) return <div className="p-6 text-center">No certificates found.</div>;

  return (
    <div className="p-6 ml-16">
      <h1 className="text-3xl font-bold mb-6">My Certificates</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {certificates.map((cert) => (
          <div key={cert._id} className="bg-white rounded-xl shadow-lg p-6 flex flex-col justify-between">
            <div className="mb-4">
              <h2 className="text-xl font-bold text-gray-900">{cert.courseName}</h2>
              <p className="text-gray-600 text-sm mb-2">
                Completed on: {new Date(cert.completionDate).toLocaleDateString()}
              </p>
              {/* <p className="text-gray-700 font-medium">
                Score: {cert.score}% -{" "}
                <span className={cert.status === "pass" ? "text-green-600" : "text-red-600"}>
                  {cert.status.toUpperCase()}
                </span>
              </p> */}
            </div>

            <a
              href={cert.s3Url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto inline-block text-center px-4 py-2 bg-gradient-to-r from-[#A73884] to-[#803A85] text-white rounded-xl font-bold hover:shadow-lg transition-all duration-300"
            >
              View Certificate
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserCertificatePage;
